import React from 'react';
import {Box, Typography} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import CheckInPhoto from "../common/CheckInPhoto";

const CheckinsGrid = ({checkins}) => {


    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 150,
            type: 'date',
            valueFormatter: (value) => new Date(value),
        },
        {field: 'status', headerName: 'Status', width: 150},
        // { field: 'notes', headerName: 'Notes', width: 300 },
        {
            field: 'photoUrl',
            headerName: 'Photo',
            width: 100,
            renderCell: (params) => (
                <CheckInPhoto src={params.value} />
            ),
        }
    ];

    return (
        <Box sx={{height: 400, width: '100%'}}>
            <Typography variant="h6" gutterBottom>
                Check-ins
            </Typography>
            <DataGrid
                rows={checkins}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
            />
        </Box>
    );
};

export default CheckinsGrid;
